"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("@engaging-tech/components");
var _SingleNavItem = _interopRequireDefault(require("./SingleNavItem"));
var _useNavContext2 = _interopRequireDefault(require("../../hooks/useNavContext"));
/**
 * Links for auxillary routes. This component is **mobile-only**.
 * @package
 */
var AuxillaryLinks = function AuxillaryLinks() {
  var _useNavContext = (0, _useNavContext2["default"])(),
    auxillaryRoutes = _useNavContext.auxillaryRoutes;
  return /*#__PURE__*/_react["default"].createElement(_components.Box, null, auxillaryRoutes.map(function (route) {
    return /*#__PURE__*/_react["default"].createElement(_SingleNavItem["default"], {
      route: route,
      key: route.description,
      rootItem: true
      // @ts-ignore
      ,
      fontSize: 16,
      mb: 3,
      mt: 3
    });
  }));
};
var _default = exports["default"] = AuxillaryLinks;